import axios from 'axios';

const API_URL = import.meta.env.VITE_CRM_API_URL || "https://dashboard.lono.co.in/api/attendance";

// Axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});
// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    // Retrieve the token using the key defined in AuthContext.jsx
    // This should be 'token' based on your AuthContext.jsx
    const token = localStorage.getItem("token"); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Helper to extract clean error messages
const handleError = (error, fallback = "Request failed") => {
  return Promise.reject(error?.response?.data || new Error(fallback));
};

export const attendanceAPI = {
  clockIn: async (staffId) =>
    api.post(`/login/${staffId}`).then(res => res.data).catch(err => handleError(err)),

  clockOut: async (staffId) =>
    api.post(`/logout/${staffId}`).then(res => res.data).catch(err => handleError(err)),

  takeBreak: async (staffId) =>
    api.post(`/staff/${staffId}/break-in`).then(res => res.data).catch(err => handleError(err)),

  endBreak: async (staffId) =>
    api.post(`/staff/${staffId}/break-out`).then(res => res.data).catch(err => handleError(err)),

  getWorkfolio: async (staffId, year, month) => {
    const params = { ...(year && { year }), ...(month && { month }) };
    return api.get(`/staff/${staffId}/workfolio`, { params })
      .then(res => res.data).catch(err => handleError(err));
  },

  getDailyStatus: async (staffId, date) =>
    api.get(`/staff/${staffId}/status`, { params: { date } })
      .then(res => res.data).catch(err => handleError(err)),

  createLeaveRequest: async (staffId, leaveData) =>
    api.post(`/leave/${staffId}`, leaveData)
      .then(res => res.data).catch(err => handleError(err)),

  getStaffLeaves: async (staffId) =>
    api.get(`/staff/${staffId}/leaves`).then(res => res.data).catch(err => handleError(err)),

  approveLeaveRequest: async (leaveId) =>
    api.post(`/leave/${leaveId}/approve`).then(res => res.data).catch(err => handleError(err)),

  rejectLeaveRequest: async (leaveId) =>    api.post(`/leave/${leaveId}/reject`).then(res => res.data).catch(err => handleError(err)),

  getAllStaffWorkfolioSummary: async ({ year, month, page, limit } = {}) => {
    const params = { ...(year && { year }), ...(month && { month }), ...(page && { page }), ...(limit && { limit }) };
    return api.get(`/staff/workfolio-summary`, { params })
      .then(res => res.data).catch(err => handleError(err, "Failed to fetch workfolio summary"));
  },

  getTodayTimeSheet: async (staffId) =>
    api.get(`/today/${staffId}`).then(res => res.data).catch(err => handleError(err))
};
